const config = {
  rowSelection: false,
  fieldControl: false,
  rowKey: 'id',
  // searchFormConfig: {labelCol: {span: 8}, wrapperCol: {span: 16}},
  columns: [
    {
      title: '线索ID',
      dataIndex: 'id',
      width: 190,
      fixed: 'left',
      render: 'clueIdRender',
    },
    {
      title: '客户姓名',
      dataIndex: 'name',
      width: 200,
      ellipsis: true
    },
    {
      title: '客户电话',
      dataIndex: 'phone',
      width: 140,
      render: 'checkPhone',
    },
    {
      title: '公司',
      dataIndex: 'orgName',
      width: 120,
    },
    {
      title: '客户来源',
      dataIndex: 'channelName',
      width: 260,
      ellipsis: true,
    },
    {
      title: '品牌',
      dataIndex: 'channelBrandName',
      width: 150,
    },
    {
      title: '军种',
      dataIndex: 'channelTypeName',
      width: 100,
    },
    {
      title: '创建日期',
      dataIndex: 'createdTime',
      itemType: 'dateTime',
      width: 180,
    },
    {
      title: '线索状态',
      dataIndex: 'statusName',
      width: 100,
      fixed: 'right',
    },
    {
      title: '需求线索',
      dataIndex: 'grossInformationFlag',
      width: 100,
      render: 'grossInfoRender',
    },
    {
      title: '当前位置',
      dataIndex: 'publicSea|dispatchExceptionType',
      width: 100,
      render: 'publicCell',
    },
  ],
  search: [
    {
      name: 'id',
      label: '线索ID',
      formItemProps: {
        getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
      },
      span: 120,
      labelProps: { width : 65 },
    },
    {
      name: 'nameLike',
      label: '客户姓名',
      labelProps: { width : 65 },
    },
    {
      name: 'phone',
      label: '客户电话',
      itemType: 'number',
      span: 120,
      labelProps: { width : 65 },
    },
    {
      name: 'orgId',
      label: '公司',
      span: 140,
      itemType: 'select',
      key: 'id',
      labelKey: 'name',
      data: 'companyList',
      events: ['onChange:onCompanyChange'],
      allowClear: true,
      showSearch: true,
      labelProps: { width : 65 },
    },
    {
      name: 'deptId',
      label: '部门',
      span: 120,
      itemType: 'select',
      key: 'id',
      data: 'saleDept',
      notFoundContent: '请选择公司或无匹配数据',
      showSearch: true,
      events: [ 'onChange:onMarketerDepChange'],
      labelProps: { width : 65 },
    },
    {
      name: 'ucenterUserId',
      label: '营销员',
      span: 120,
      itemType: 'select',
      key: 'ucenterUserId',
      labelKey: 'userName',
      data: 'salesman',
      notFoundContent: '请选择部门或无匹配数据',
      showSearch: true,
      labelProps: { width : 65 },
    },
    {
      name: 'callUserId',
      label: '云客服',
      itemType: 'select',
      key: 'ucenterUserId',
      labelKey: 'userName',
      data: 'seat',
      span: 120,
    },
    {
      name: 'advertUserId',
      itemType: 'select',
      key: 'ucenterUserId',
      labelKey: 'userName',
      data: 'anchor',
      label: '优化师',
    },
    {
      name: 'status',
      label: '线索状态',
      itemType: 'select',
      key: 'key',
      labelKey: 'description',
      data: 'clueStatusEnum',
      allowClear: true,
      labelProps: { width : 65 },
    },
    {
      name: 'buildingId',
      label: '楼盘名称',
      span: 120,
      itemType: 'select',
      key: 'id',
      labelKey: 'name',
      data: 'buildingId',
      notFoundContent: '请选择公司或无匹配数据',
      showSearch: true,
      labelProps: { width : 65 },
    },
    {
      name: 'channelBrandId',
      label: '品牌',
      span: 120,
      itemType: 'select',
      key: 'id',
      labelKey: 'brandName',
      data: 'channelBrand',
      showSearch: true,
      labelProps: { width : 65 },
    },
    {
      name: 'channelTypeId',
      label: '军种',
      itemType: 'select',
      key: 'id',
      labelKey: 'typeName',
      data: 'channelType',
      labelProps: { width : 65 },
    },
    {
      name: 'channelIds',
      label: '客户来源',
      itemType: 'tree',
      data: 'channels',
      labelKey: 'label',
      key: 'id',
      treeCheckable: true,
      allowClear: true,
      showSearch: true,
    },
    {
      name: 'dispatchDate',
      label: '派单时间',
      placeholder: ['派单时间起', '止'],
      span: 140,
      itemType: 'autoDate',
      showTime: 'true',
      labelProps: { width : 65 },
    },
    {
      name: 'createDate',
      label: '创建时间',
      placeholder: ['创建时间起', '止'],
      span: 140,
      itemType: 'autoDate',
      showTime: 'true',
      labelProps: { width : 65 },
    },
  ],
  footer: [
    {
      label: '导出',
      itemType: 'custom',
      render: 'exportRender'
    },
  ],
}

export default config
